/** Do not edit directly **/
/** Do not edit directly **/
/**
 * @prop --sy-dialog-content-padding-top: Dialog content top padding.
 * @prop --sy-dialog-content-padding-bottom: Dialog content bottom padding.
 * @prop --sy-dialog-content-padding-left: Dialog content left padding.
 * @prop --sy-dialog-content-padding-right: Dialog content right padding.
 * @prop --sy-dialog-content-color: Dialog content color.
 * @prop --sy-dialog-content-font-size: Dialog content font size.
 * @prop --sy-dialog-content-text-decoration: Dialog content text decoration.
 * @prop --sy-dialog-content-font-family: Dialog content font family.
 * @prop --sy-dialog-content-font-weight: Dialog content font weight.
 * @prop --sy-dialog-content-font-style: Dialog content font style.
 * @prop --sy-dialog-content-font-stretch: Dialog content font stretch.
 * @prop --sy-dialog-content-letter-spacing: Dialog content letter spacing.
 * @prop --sy-dialog-content-line-height: Dialog content line height.
 */
*,
:host,
*::before,
*::after {
  box-sizing: border-box;
}

:host {
  flex: 1 1 auto;
  padding-top: var(--sy-dialog-content-padding-top, 0);
  padding-right: var(--sy-dialog-content-padding-right, var(--sy-spacer-4));
  padding-bottom: var(--sy-dialog-content-padding-bottom, 0);
  padding-left: var(--sy-dialog-content-padding-left, var(--sy-spacer-4));
  color: var(--sy-dialog-content-color, var(--sy-foreground-high-emphasis));
  font-size: var(--sy-dialog-content-font-size, var(--sy-content-regular-body-font-size));
  text-decoration: var(--sy-dialog-content-text-decoration, var(--sy-content-regular-body-text-decoration));
  font-family: var(--sy-dialog-content-font-family, var(--sy-content-regular-body-font-family));
  font-weight: var(--sy-dialog-content-font-weight, var(--sy-content-regular-body-font-weight));
  font-style: var(--sy-dialog-content-font-style, var(--sy-content-regular-body-font-style));
  font-stretch: var(--sy-dialog-content-font-stretch, var(--sy-content-regular-body-font-stretch));
  letter-spacing: var(--sy-dialog-content-letter-spacing, var(--sy-content-regular-body-letter-spacing));
  line-height: var(--sy-dialog-content-line-height, var(--sy-content-regular-body-line-height));
}